import { render, staticRenderFns } from "./ColorPickerInput.vue?vue&type=template&id=ca80a40e&scoped=true"
import script from "./ColorPickerInput.vue?vue&type=script&lang=js"
export * from "./ColorPickerInput.vue?vue&type=script&lang=js"
import style0 from "./ColorPickerInput.vue?vue&type=style&index=0&id=ca80a40e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca80a40e",
  null
  
)

export default component.exports